import React from 'react'
import {
  type MappingListItem,
  useGetCQGSymbolTenantCommodityMappingDetails,
} from 'src/api/queries/microservices/trade-commodity-config'
import { Button, Placeholders } from 'src/ui'
import MappingEditorForm from './commodity-symbol-mapping-editor-form'

type MappingEditorProps = {
  symbol: MappingListItem
  tenantId: string
  canEdit: boolean
  onClose: () => void
}

export default function MappingEditor({ symbol, tenantId, canEdit, onClose }: MappingEditorProps) {
  const detailsQuery = useGetCQGSymbolTenantCommodityMappingDetails(symbol.categorySymbol)

  if (detailsQuery.isPending) return <Placeholders.LoadingState mt={8} />
  if (detailsQuery.isError || !detailsQuery.data) {
    return (
      <>
        <Placeholders.FailedState mt={8} />
        <Button display="block" mx="auto" onClick={onClose}>
          Back to mappings
        </Button>
      </>
    )
  }

  return (
    <MappingEditorForm
      key={symbol.categorySymbol}
      symbol={symbol}
      mapping={detailsQuery.data}
      locations={detailsQuery.data.locationMappings}
      tenantId={tenantId}
      canEdit={canEdit}
      onClose={onClose}
    />
  )
}
